/* Baior Mobile Menu — paprasta open/close logika, be Dawn priklausomybių */
(function () {
  'use strict';

  function init() {
    var toggle = document.querySelector('[data-baior-menu-toggle]');
    var menu = document.querySelector('[data-baior-menu]');
    if (!toggle || !menu) return;

    // Perkelti drawer'į tiesiai į <body>, kad jokie ancestor (pvz. .header-wrapper
    // su `backdrop-filter`) nesukurtų containing block fixed elementui ir panel
    // galėtų užimti visą ekraną.
    if (menu.parentNode !== document.body) {
      document.body.appendChild(menu);
    }

    var panel = menu.querySelector('.baior-mobile-menu__panel');
    var lastFocused = null;

    function open() {
      if (menu.classList.contains('is-open')) return;
      menu.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
      });
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Uždaryti meniu');
      document.body.classList.add('baior-mobile-menu-open');
      lastFocused = document.activeElement;
      if (panel) {
        panel.setAttribute('tabindex', '-1');
        panel.focus({ preventScroll: true });
      }
    }

    function close() {
      if (!menu.classList.contains('is-open')) return;
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Atidaryti meniu');
      document.body.classList.remove('baior-mobile-menu-open');

      var hide = function () {
        if (!menu.classList.contains('is-open')) {
          menu.hidden = true;
        }
        menu.removeEventListener('transitionend', onEnd);
      };
      var onEnd = function (e) {
        if (e.target === menu.querySelector('.baior-mobile-menu__panel')) hide();
      };
      menu.addEventListener('transitionend', onEnd);
      // Saugiklis jei transitionend neįvyksta
      setTimeout(hide, 400);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus({ preventScroll: true }); } catch (_) {}
      }
    }

    function toggleMenu() {
      if (menu.classList.contains('is-open')) close();
      else open();
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      toggleMenu();
    });

    // Bet kuris [data-baior-menu-close] elementas uždaro
    menu.addEventListener('click', function (e) {
      var t = e.target.closest('[data-baior-menu-close]');
      if (t) {
        e.preventDefault();
        close();
      }
    });

    // Paspaudus bet kurią nuorodą — uždaryti, kad neliktų atviras po navigation
    menu.addEventListener('click', function (e) {
      var link = e.target.closest('[data-baior-menu-link]');
      if (!link) return;
      // Ne uždaryti, jei tai vidinis akordeono summary
      if (link.closest('summary')) return;
      // Atidėti, kad naršyklės hash navigavimas suveiktų
      setTimeout(close, 60);
    });

    // ESC uždaro
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        close();
      }
    });

    // Jei persijungiama į desktop — uždaryti
    var mql = window.matchMedia('(min-width: 990px)');
    var onMql = function (e) { if (e.matches) close(); };
    if (mql.addEventListener) mql.addEventListener('change', onMql);
    else if (mql.addListener) mql.addListener(onMql);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
